module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.items.length > 0),
      expression: "items.length > 0"
    }],
    staticClass: "animated fadeIn"
  }, [_c('b-card', {
    attrs: {
      "id": "demoList"
    }
  }, [_c('div', {
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_c('b-button', {
    attrs: {
      "to": {
        name: 'welcome-list',
        params: {
          initCategoryCode: this.$route.params.categoryCode,
          initServiceCode: this.$route.params.serviceCode
        }
      },
      "size": "sm",
      "variant": "link"
    }
  }, [_c('i', {
    staticClass: "fa fa-chevron-left"
  })]), _vm._v("\n      样例信息\n    ")], 1), _vm._v(" "), _vm._l((_vm.items), function(item, index) {
    return _c('b-row', {
      key: index,
      attrs: {
        "id": 'pr' + item.code + index.toString()
      }
    }, [_c('b-col', {
      attrs: {
        "sm": "2"
      }
    }), _vm._v(" "), _c('b-col', [_c('hr', {
      staticClass: "hr-fade-content",
      attrs: {
        "data-content": item.name
      }
    }), _vm._v(" "), (item.ismd) ? _c('v-md-preview', {
      attrs: {
        "text": item.desc
      }
    }) : _c('div', {
      staticStyle: {
        "padding": "20px 12px !important"
      },
      domProps: {
        "innerHTML": _vm._s(item.desc)
      }
    })], 1), _vm._v(" "), _c('b-col', {
      attrs: {
        "sm": "2"
      }
    })], 1)
  })], 2), _vm._v(" "), _c('b-navbar', {
    staticClass: "flex-column demo-nav"
  }, [_c('b-navbar-brand', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("目录")]), _vm._v(" "), _c('b-nav', {
    attrs: {
      "pills": "",
      "vertical": ""
    }
  }, [_vm._l((_vm.items), function(item, index) {
    return [_c('b-nav-item', {
      key: index
    }, [_c('b-button', {
      directives: [{
        name: "scroll-to",
        rawName: "v-scroll-to",
        value: ('#pr' + item.code + index.toString()),
        expression: "'#pr' + item.code + index.toString()"
      }],
      staticClass: "nav-btn",
      attrs: {
        "variant": "link"
      }
    }, [_vm._v(_vm._s(item.name))])], 1)]
  })], 2)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler.js?id=data-v-61b30e0e!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/welcomeSetting/DemoDisplay.vue
// module id = XhxK
// module chunks = 4